export const PoemSuperBlue = () => {
    return (
        <div id="002" className="">
            <p>half human, half machine,</p>
            <p>hugs with friends, ear piercings,</p>
            <p>the smell of sun-bleached hair,</p>
            <p>teeth fillings,</p>
            <p>microplastics in my fucking guts,</p>
            <p>lead in my bloodflow and dirt on my shoes,</p>
            <p>past, future and right now,</p>
            <p>all of it in focus,</p>
            <p>rose-tinted present,</p>
            <p>good first impressions.</p>
            <p>nothing like my profile picture,</p>
            <p>nothing like my voice messages</p>
            <p>or letters, or emails,</p>
            <p>did you ever look at yourself in a cracked mirror</p>
            <p>and it looks like there's seven of you looking back?</p>
            <p>life on a volume slider,</p>
            <p>life like one of those little choking turtle graphics</p>
            <p>on the packaging of plastic-based wet wipes,</p>
            <p>if you're ever gonna meet me, wake me up to reality</p>
            <p>yes thank you.</p>
            <p>with each day i live </p>
            <p>the sky gets more and more blue,</p>
            <p>everything electronic,</p>
            <p>the colors are beautiful indeed,</p>
            <p>but the light from the screen</p>
            <p>
                makes my head and the back of my eyes hurt like hell the next
                morning.
            </p>
        </div>
    );
};
